import { useEffect, useState } from 'react'
import { LottieLoader } from './LottieLoader'

type BrandedLoaderProps = {
  size?: number
  className?: string
  'aria-label'?: string
}

export function BrandedLoader({ size = 96, className, 'aria-label': ariaLabel = 'Loading' }: BrandedLoaderProps) {
  // Respect the OS-level reduced-motion preference: skip the looping animation and show a static frame.
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const handleChange = () => setPrefersReducedMotion(mediaQuery.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return (
    <LottieLoader
      ariaLabel={ariaLabel}
      autoplay={!prefersReducedMotion}
      className={className}
      fallbackClassName="text-brand-500"
      loop={!prefersReducedMotion}
      size={size}
      src="/animations/branded-loader.lottie"
    />
  )
}
